import styled from 'styled-components';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { PAGES } from 'constants/pages';

import { TicketsList } from './components/TicketsList';

export const Tickets = () => {
    return (
        <Container data-test="tickets-page">
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.tickets} />
                </HeaderTitle>
            </Header>
            <Content>
                <TicketsList />
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;
